import { useMemo } from 'react'
import { useRoutes } from 'react-router-dom'

import { SecuredRoute } from '../components'

const secureRoute = route => ({
  ...route,
  element: route?.secured ? (
    <SecuredRoute role={route.secured}>{route.element}</SecuredRoute>
  ) : (
    route.element
  ),
  children: route?.children?.map(secureRoute)
})

export function useSecuredRoutes(routes) {
  const securedRoutes = useMemo(() => routes.map(secureRoute), [routes])
  return useRoutes(securedRoutes)
}

export default useSecuredRoutes
